module.exports = __webpack_public_path__ + "static/img/qsfn1.e949878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qsfn1.png
// module id = luJE
// module chunks = 0